import React from "react";
import {AppButton} from "../button";
import './index.scss';

export const AppFormContainer = ({children, showButton, buttonText, formId, className}) => {
	return (
		<div className={`form-wrapper ${className?className:''}`} >
			{children}
			{showButton && <AppButton form={formId} type="submit" className="form-button">{buttonText}</AppButton>}
		</div>
	)
};
